import { resolveLocalizedSkillName } from '#pplx/frontend/apps/ask/skills/getComposerSkillMention.js';
import { useSelectableSkills } from '#pplx/frontend/apps/ask/skills/hooks/useSelectableSkills.js';
import { getSkillMentionURL } from '#pplx/frontend/apps/ask/skills/utils/getSkillMentionURL.js';
import { useCallback, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
const SKILLS_TYPEAHEAD_LIMIT = 100;
export function useSkillsTypeahead({ enabled = true, collectionUuid }) {
    const intl = useIntl();
    const [isTriggered, setIsTriggered] = useState(false);
    // Skills run inside Computer mode, which sidecar builds can never enter
    // (see useSelectedSearchMode.ts). Hide them at the source so every sidecar
    // surface gets the right behavior without per-caller variant lists.
    const effectiveEnabled = enabled && !import.meta.env.VITE_IS_SIDECAR_BUILD;
    const { skills } = useSelectableSkills({
        app: 'computer',
        limit: SKILLS_TYPEAHEAD_LIMIT,
        enabled: effectiveEnabled && isTriggered,
        collectionUuid,
    });
    const onTrigger = useCallback(() => {
        setIsTriggered(true);
    }, []);
    const skillsTypeaheadOptions = useMemo(() => skills.map((skill) => {
        const localizedName = resolveLocalizedSkillName({ skill, intl });
        return {
            uuid: skill.id,
            variant: 'skills',
            label: skill.name,
            localizedName,
            searchAliases: localizedName ? [skill.name, localizedName] : [skill.name],
            url: getSkillMentionURL(skill),
            convertToNode: true,
        };
    }), [intl, skills]);
    return useMemo(() => ({
        isSkillsTypeaheadEnabled: effectiveEnabled,
        skillsTypeaheadOptions,
        onTrigger,
    }), [effectiveEnabled, skillsTypeaheadOptions, onTrigger]);
}
//# sourceMappingURL=useSkillsTypeahead.js.map